import { render, staticRenderFns } from "./ButtonActionSmall.vue?vue&type=template&id=1f7e4628&scoped=true&"
import script from "./ButtonActionSmall.vue?vue&type=script&lang=js&"
export * from "./ButtonActionSmall.vue?vue&type=script&lang=js&"
import style0 from "./ButtonActionSmall.vue?vue&type=style&index=0&id=1f7e4628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7e4628",
  null
  
)

export default component.exports